import { fetchIntrospectionPage } from '../../../connections/services/language-services/introspectionQuery';
import type { DdlEdit } from '../../../sql-resolver/types';
import type { ResolveDdlEditCtx } from './resolveDdlEdit';

/** MySQL password DDL only accepts string literals, whose escaping depends on sql_mode. */
export async function prepareDdlEditContext(
  edit: DdlEdit,
  ctx: ResolveDdlEditCtx,
): Promise<ResolveDdlEditCtx> {
  if (ctx.service.engineId !== 'mysql' || ctx.applyOptions?.mysqlNoBackslashEscapes !== undefined) return ctx;
  const password = edit.op === 'create-user' ? edit.user.mysqlIdentifiedBy
    : edit.op === 'alter-user' ? edit.change.mysqlIdentifiedBy : undefined;
  if (password === undefined || !/[\\\0]/u.test(password)) return ctx;
  // Disconnected SQL buffers use MySQL's default literal mode.
  if (!ctx.connectionId) return ctx;
  const result = await fetchIntrospectionPage({
    engine: 'mysql', connectionId: ctx.connectionId, database: ctx.database ?? '',
    label: 'ddl-password-mode', sql: 'SELECT @@SESSION.sql_mode AS sqlMode',
  });
  const sqlMode = result.rows[0]?.sqlMode;
  if (!result.ok || typeof sqlMode !== 'string') {
    throw new Error('Cannot read MySQL SQL mode to escape this password. Reconnect and try again.');
  }
  return {
    ...ctx,
    applyOptions: { ...ctx.applyOptions, mysqlNoBackslashEscapes: sqlMode.split(',').some((mode) => mode.trim().toUpperCase() === 'NO_BACKSLASH_ESCAPES') },
  };
}
